import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class MenuStateService<T = string> {
  private readonly menuIdSubject = new BehaviorSubject<T>(null);
  private readonly closeSubject = new Subject<void>();

  public get currentMenuId$(): Observable<T> {
    return this.menuIdSubject.asObservable();
  }

  public get currentMenuId(): T {
    return this.menuIdSubject.value;
  }

  public setCurrentMenuId(value: T, resetSubject = false): void {
    this.menuIdSubject.next(value);
    resetSubject && this.menuIdSubject.next(null);
  }

  public get close$(): Observable<void> {
    return this.closeSubject.asObservable();
  }

  public closeAll(): void {
    this.closeSubject.next();
  }
}
